<div class="collapsible-row">
  <table class="collapsible-table" aria-describedby="meter-wizard">
    <th scope="sonarqubefix" class="sonarqubefix"></th>
    <tr class="table-row">
      <td class="table-cell meter-checkbox">
        <section class="example-section">
          <mat-checkbox
            [checked]="isChecked"
            (change)="onCheckboxChange($event)"
            [id]="sortedData[0].guid"
            [value]="sortedData[0]"
            class="example-margin"
          ></mat-checkbox>
        </section>
      </td>
      <td class="table-cell meter-type" *ngIf="sortedData[0].meterTypeCode">
        <app-svg-icon
          class="table-icon"
          src="./assets/icons/{{ getMeterTypeImage(sortedData[0].meterTypeCode, sortedData[0].deviceId) }}"
          title="{{ sortedData[0].deviceId === null ? sortedData[0].meterTypesName : ('module.meterReading.remoteName' | translate) }}"
        ></app-svg-icon>
      </td>
      <td class="table-cell energy-type" [ngClass]="{ remote: hasDeviceEUI }" *ngIf="sortedData[0].energyTypesName">
        <img
          alt="energy-type-img"
          class="table-icon"
          src="./assets/icons/{{ getEnergyTypeImage(sortedData[0].energyTypesName) }}"
          title="{{ sortedData[0].energyTypesName }}"
        />
      </td>
      <td class="table-cell address">{{ sortedData[0] | getAddress }}</td>
      <td class="table-cell object">
        <ng-container *ngIf="sortedData[0].objectType; else displayNullObjectType">
          {{ sortedData[0].objectType }}
        </ng-container>
        <ng-template #displayNullObjectType>
          <app-svg-icon
            matTooltip=" {{ 'module.meterReading.objectHoverMessage' | translate }}"
            matTooltipPosition="above"
            matTooltipClass="object-hover-message"
            class="icon-info"
            src="./assets/icons/ep_info_icon.svg"
          ></app-svg-icon>
          <span class="object-null-text">{{ 'module.meterReading.objectTypeIsNull' | translate }}</span>
        </ng-template>
      </td>
      <td class="table-cell meter-number">
        <div class="meter-sensor-number">
          <div *ngIf="sortedData[0].meterNumber">Z: {{ sortedData[0].meterNumber }}</div>
          <div *ngIf="sortedData[0].marketLocationKey" class="malo-row">
            <span>M: </span>
            <span>{{ sortedData[0].getMarketLocationKeyWithOutLeadingZeros() }}</span>
          </div>
          <div *ngIf="sortedData[0].deviceId && !!authService.permissions.SENSOR_DATA">S: {{ sortedData[0].getSensorNumberWithOutLeadingZeros() }}</div>
        </div>
      </td>
    </tr>
    <div class="line" *ngIf="shown">&nbsp;</div>
  </table>
</div>
